<template>
  <div class="kpt-documents-root kpt-single-page">
    <vue-headful title="Documents" />
    <div class="hero is-primary is-bold">
      <div class="hero-body">
        <div class="hero-pin-bar">
          <!-- <font-awesome-icon :icon="['far', 'thumbtack']" @click="pinToDash('documentsList', { name: 'Documents' })" title="Pin to Dashboard" class="has-cursor-pointer" /> -->
        </div>
        <div class="kpt-docu-search">
          <h2 class="title">Documentation</h2>
          <h5 class="subtitle">Search over {{documents.length}} technical documents</h5>
          <b-field>
            <b-input :loading="searchLoading" type="text" placeholder="Search Documentation..." @keydown.native.enter="triggerSearch" v-model="searchText"></b-input>
          </b-field>
        </div>
      </div>
    </div>
    <br>
    <div class="container"  v-if="searchResults.length == 0">
      <div class="kpt-document-topics mt-3 pl-5 pr-5">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
    <br>
    <div class="container" v-if="searchResults.length > 0">
      <div class="kpt-document-search">
        <h4 class="is-flex" style="margin-top: 24px; justify-content: space-between;"><span>Search Results</span> <a class="is-size-6" @click="nullSearch">Back to Topics</a></h4>
        <hr>
        <document-search-results :results="searchResults" :loading="searchLoading" @null-search="nullSearch"></document-search-results>
      </div>
    </div>
  </div>
</template>
<script>
import { pinToDashMixin } from '../shared/mixins/pinToDash';
import DocumentSearchResults from './components/DocumentSearchResults.vue';

export default {
  mixins: [pinToDashMixin],
  components: {
    DocumentSearchResults
  },
  data() {
    return {
      rootDir: null,
      searchText: null
    }
  },
  async created() {
    await this.$store.dispatch('fetchStorageFiles', 'documents');
  },
  computed: {
    documents() {
      return this.$store.state.storage.documents;
    },
    featuredDocs() {
      // this is driven from the metadata on the file contained within Azure blob storage
      return this.$store.state.storage.documents.filter(d => d.metadata && d.metadata.featured == 'true');
    },
    recommendedDocs() {
      // this is driven from the metadata on the file contained within Azure blob storage
      return this.$store.state.storage.documents.filter(d => d.metadata && d.metadata.recommended == 'true');
    },
    searchResults() {
      return this.$store.state.storage.documentsSearchResults;
    },
    searchLoading() {
      return this.$store.state.storage.documentsSearching;
    }
  },
  methods: {
    async triggerSearch() {
      // KyAnalytics client plugin, event tracker
      this.$kya.event('documentation', 'triggerDocumentationSearch', 'Documents searched with text', { searchText: this.searchText });
      await this.$store.dispatch('searchDocuments', this.searchText)
    },
    nullSearch() {
      this.searchText = null;
      this.$store.commit('clearDocumentSearchResults');
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../styles/_colors';

.kpt-documents-root {
  min-height: 100%;
  background-color: $white-bis;

  .hero-pin-bar {
    margin-top: -32px;
    text-align: right;
  }

  .kpt-documents-content {
    padding: 12px;
    height: calc(100% - 50px);
    overflow-x: hidden;
  }

  .kpt-docu-search {
    display: flex;
    flex-direction: column;
    align-items: center;

    .field {
      width: 35rem;
    }
  }

  .kpt-document-search {
    height: 100%;
  }
}
</style>
